import Vue from "vue";

function getRef(orgId) {
  return Vue.prototype.$db
    .collection("organisations")
    .doc(orgId)
    .collection("feedback");
}

export async function getById(orgId, id) {
  return getRef(orgId)
    .doc(id)
    .get();
}

export async function list(orgId) {
  return getRef(orgId).get();
}

export async function countAlerts(orgId) {
  const dt = new Date();
  return getRef(orgId)
    .where("expiryDate", ">=", dt)
    .get();
}
export async function save(orgId, payload) {
  const obj = Object.assign({}, payload);

  if (obj.id != undefined) {
    return getRef(orgId)
      .doc(obj.id)
      .update(obj);
  } else {
    return getRef(orgId).add(obj);
  }
}
